import { motion } from 'motion/react';
import styled, { css, keyframes } from 'styled-components';
import { getSizeStyles, SizeTypes } from '../sizes';
import { DEFAULT_COLORS } from '../colors';

export const DropdownContainer = styled.div<{
  isError?: boolean;
  isDisabled?: boolean;
  width?: string;
  background?: 'grey' | 'white';
  noBorder?: boolean;
}>`
  box-sizing: border-box;
  width: ${({ width }) => (width ? width : '100%')};
  border-radius: 4px;
  background-color: ${({ background }) =>
    background ? background : 'rgba(242, 242, 242, 1)'};
  position: relative;
  ${({ noBorder, isError }) =>
    noBorder
      ? css`
          border: 1px solid transparent;
        `
      : css`
          border: ${({ theme }) =>
            isError
              ? `1px solid ${theme.palette.error}`
              : `1px solid ${theme.palette.primary}`};
        `}

  &:focus,
  &:focus-within {
    border: ${({ theme }) => `1px solid ${theme.palette.primary}`};
    outline: none;
  }

  color: ${({ isDisabled, theme }) =>
    isDisabled ? theme.palette.text.disabled : 'inherit'};

  ${({ theme }) => theme.breakpoints.down('md')} {
    position: unset;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    position: relative;
  }
`;

export const DropdownHeader = styled.div<{
  size: SizeTypes;
  isLoading: boolean;
}>`
  cursor: pointer;
  display: flex;
  justify-content: ${({ isLoading }) =>
    isLoading ? 'center' : 'space-between'};
  align-items: center;
  ${({ size }) => getSizeStyles(size)};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`;

export const DropdownBody = styled(motion.div)<{ width?: number }>`
  z-index: 3;
  background-color: white;
  border-radius: 4px;
  position: absolute;
  box-sizing: border-box;
  width: 100%;

  border-top: 1px solid #e5e8ec;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.125);
  max-height: 300px;
  overflow-y: scroll;

  width: ${props => (props.width ? `${props.width}px` : '50px')};
`;

export const Option = styled.div`
  padding: 10px;
  text-align: center;
  &:hover {
    cursor: pointer;
    background: rgba(242, 242, 242, 1);
  }
`;

const loadingSpinner = keyframes`
  from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
`;

export const DropdownLoadingSpinner = styled.div<{
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => (width ? width : '10px')};
  height: ${({ height }) => (height ? height : '10px')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid rgba(0, 0, 0, 0.23);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${loadingSpinner} 1s ease infinite;
`;

export const DropdownLabel = styled.div<{ isPlaceholder?: boolean }>`
  color: ${({ isPlaceholder }) =>
    isPlaceholder ? DEFAULT_COLORS.sky.muted : 'inherit'};
  /* font-size: ${({ isPlaceholder }) =>
    isPlaceholder ? '0.9rem' : 'inherit'}; */
`;
